<template>
    <div class="icon-hamburger">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
export default {
    name: 'HamburgerIcon',
}
</script>

<style lang="scss">
.icon-hamburger {
    width: 30px;
    height: 22.5px;
    position: relative;
    margin: 25px auto;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;

    top: 2px;
    right: 0px;
    margin: 22px;
}

.icon-hamburger span {
    display: block;
    position: absolute;
    height: 4.5px;
    height: 3px;
    width: 100%;
    background: var(--bzioup-bg-color-Z);
    border-radius: 4.5px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
}

.icon-hamburger span:nth-child(1) {
    top: 0px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
}

.icon-hamburger span:nth-child(2) {
    top: 9px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
}

.icon-hamburger span:nth-child(3) {
    top: 18px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
}

.icon-hamburger.open span:nth-child(1) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    top: -1.5px;
    left: 4px;
}

.icon-hamburger.open span:nth-child(2) {
    width: 0%;
    opacity: 0;
}

.icon-hamburger.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 19.5px;
    left: 4px;
}
</style>
